import { css } from 'lit';
import componentStyles from '../styles/component.styles.js';
import { theme } from '../themes/theme.js';
export default css `
    ${componentStyles}

    :host {
        ${theme.colors.cssColor('text-default')};
        display: block;
    }

    .watching-count {
        display: flex;
        align-items: center;
        gap: var(--sgdf-spacing-x-small);
    }
`;
//# sourceMappingURL=watching-count.styles.js.map